import React from "react";

export default function DayIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.25C8.2785 5.25 5.25 8.2785 5.25 12C5.25 15.7215 8.2785 18.75 12 18.75C15.7215 18.75 18.75 15.7215 18.75 12C18.75 8.2785 15.7215 5.25 12 5.25ZM12 17.25C9.105 17.25 6.75 14.895 6.75 12C6.75 9.105 9.105 6.75 12 6.75C14.895 6.75 17.25 9.105 17.25 12C17.25 14.895 14.895 17.25 12 17.25ZM11.25 0H12.75V3H11.25V0ZM11.25 21H12.75V24H11.25V21ZM21 11.25H24V12.75H21V11.25ZM0 11.25H3V12.75H0V11.25ZM17.835 18.894L18.894 17.8335L21.0165 19.956L19.956 21.0165L17.835 18.894ZM2.985 4.044L4.044 2.9835L6.1665 5.106L5.106 6.1665L2.985 4.044ZM2.985 19.956L5.106 17.8335L6.1665 18.894L4.044 21.0165L2.985 19.956ZM17.835 5.106L19.956 2.9835L21.0165 4.044L18.894 6.1665L17.835 5.106Z"
        fill="#959595"
      />
    </svg>
  );
}
